import useCloseRequestsOnLocationChange from '../../hooks/use-close-requests-on-location-change';

export const CloseRequestsOnLocationChange = () => {
  const closeRequestsOnLocationChange = useCloseRequestsOnLocationChange();
  return closeRequestsOnLocationChange;
};
